/**
 * DSP API key — fetched from config service at runtime so it never lives in the JS bundle.
 *
 * Priority order:
 * 1. window.__DSP_API_KEY__ (injected by server/edge before bundle)
 * 2. Config service (https://config.chillfree.tv/config?company_id=...)
 * 3. Build-time REACT_APP_DSP_API_KEY (dev only fallback — never set in production builds)
 */

const COMPANY_ID = '68e42982e052240074037638';
const CONFIG_SERVICE_URL = 'https://config.chillfree.tv/config';

const buildTimeFallback = process.env.REACT_APP_DSP_API_KEY || '';

// Sync getter — returns whatever is set on window right now
export function getDspApiKey() {
  if (typeof window !== 'undefined' && window.DSP_API_KEY) {
    return window.DSP_API_KEY;
  }
  return buildTimeFallback;
}

/**
 * Fetch the DSP API key from the config service and set it on window.
 * Call this before rendering the app. Returns a promise that resolves
 * when the key is ready (or falls back gracefully on error).
 */
export async function initDspApiKey() {
  if (typeof window === 'undefined') return;

  // Already injected server-side
  if (window.__DSP_API_KEY__) {
    window.DSP_API_KEY = window.__DSP_API_KEY__;
    return;
  }

  try {
    const res = await fetch(`${CONFIG_SERVICE_URL}?company_id=${COMPANY_ID}`, {
      cache: 'no-store',
    });
    if (!res.ok) throw new Error(`Config service returned ${res.status}`);
    const data = await res.json();
    if (data.dsp_api_key) {
      window.DSP_API_KEY = data.dsp_api_key;
      return;
    }
  } catch (err) {
    console.warn('⚠️ Could not fetch DSP config:', err.message);
  }

  // Fallback: build-time value (dev only)
  if (buildTimeFallback) {
    window.DSP_API_KEY = buildTimeFallback;
  }
}
